import { COUNTRY } from '@mango-engineering/maknet-client-sdk/lib/shop/types';

export const getThemeBasedIconColor = (country: COUNTRY) => {
  if (country === COUNTRY.CAMBODIA) {
    return {
      background: '#D4E6F7',
      primary: '#0066B9',
      secondary: '#58A2E8',
    };
  }
  return {
    background: '#FFD8D9',
    primary: '#E82026',
    secondary: '#F73B41',
  };
};
